<div class="payment-drawer-container" [class.payment-drawer-container--closing]="isClosing">
  <!-- Header -->
  <div class="rp-drawer-header">
    <div class="rp-drawer-close-row">
      <button class="rp-close-btn" (click)="onNoClick()">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
      <span class="rp-close-label" (click)="onNoClick()">Close</span>
    </div>

    <h2 class="rp-drawer-title">
      {{ editMode ? 'Edit payment entry' : 'Record payment ledger' }}
    </h2>
    <p class="rp-drawer-subtitle" style="margin-bottom: 12px;">
      {{ editMode ? 'Modify this offline transaction record.' : 'Record a payment you’ve already received, such as cash,
      check, or bank payment.' }}
    </p>

    <div class="payment-drawer__tag-row">
      <span class="payment-drawer__tag-status" [class.payment-drawer__tag-status--edit]="editMode">
        {{ editMode ? 'EDIT MODE' : 'RECORD PAYMENT' }}
      </span>
      <span class="payment-drawer__tag-ref" *ngIf="invoiceNumber">
        {{ invoiceNumber }}
      </span>
      <button type="button" *ngIf="orderId && !editMode" [matMenuTriggerFor]="invoiceMenu" (click)="getFinancialList()"
        class="btn-select-invoice">
        Select Invoice
      </button>

      <mat-menu class="profile-menu-dropdown customer-menu-width sorting-menu sku-filter" #invoiceMenu="matMenu"
        xPosition="after">
        <ul class="m-0 p-0 items-ul position-relative" *ngIf="invoiceList?.length > 0">
          <li class="list-down sku-list" *ngFor="let invoice of invoiceList" [value]="invoice?.iqp_id"
            (click)="selectInvoice(invoice)">
            <div class="d-flex align-items-center justify-content-between menu-title">
              <p class="text-truncate header-menu mb-0">{{ invoice?.iqp_invoice_number }}</p>
              <div class="draft-badge yet-progress mb-0">₹ {{ invoice?.amount }}</div>
            </div>
          </li>
        </ul>
        <p *ngIf="invoiceList?.length < 1" class="no-data">No data available</p>
      </mat-menu>
    </div>
  </div>

  <!-- Body -->
  <div class="payment-drawer__body">
    <!-- Settlement Status Bar -->
    <div class="settlement-status">
      <app-section-header
        title="Live Settlement Status"
        [noBorder]="true"
        [isFirst]="true"
        customClass="settlement-section-header">
      </app-section-header>

      <div class="settlement-status__grid">
        <div class="settlement-status__cell">
          <app-label text="Total Due" customClass="mb-1"></app-label>
          <span class="settlement-status__amount">
            {{ (editMode ? dueAmount : amountDue) | divide }}
          </span>
        </div>
        <div class="settlement-status__cell">
          <app-label text="This Payment" customClass="mb-1"></app-label>
          <span class="settlement-status__amount settlement-status__amount--accent">
            {{ (paymentForm.get('iqp_partly_pmnt_amnt')?.value || 0) | divide }}
          </span>
        </div>
        <div class="settlement-status__cell" [class.settlement-status__cell--settled]="getRemainingDue() <= 0.001">
          <app-label text="Projected Due" customClass="mb-1"></app-label>
          <span class="settlement-status__amount">
            {{ getRemainingDue() | divide }}
          </span>
        </div>
      </div>

      <!-- Warnings/Cautions -->
      <div *ngIf="editMode ? checkIfDueAmountExceeds() : checkIfAmountExceeds()"
        class="settlement-status__overpay-warn mt-2">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z"></path>
          <line x1="12" y1="9" x2="12" y2="13"></line>
          <line x1="12" y1="17" x2="12.01" y2="17"></line>
        </svg>
        <span>Entered payment exceeds the outstanding amount.</span>
      </div>
    </div>

    <!-- Form Section -->
    <form [formGroup]="paymentForm" class="payment-form">
      <!-- Date & Amount Row -->
      <div class="payment-form__row-2">
        <div class="payment-form__field">
          <app-date-picker
            label="Payment Date"
            [required]="true"
            formControlName="iqp_paid_date"
            [maxDate]="today">
          </app-date-picker>
        </div>

        <div class="payment-form__field">
          <div class="d-flex justify-content-between align-items-center mb-1">
            <app-label text="Received Amount" [mandatory]="true" customClass="mb-0"></app-label>
            <app-checkbox
              label="Full Payment"
              [(ngModel)]="isFullPayment"
              [ngModelOptions]="{standalone: true}"
              (checkboxChange)="toggleFullPayment($event)">
            </app-checkbox>
          </div>
          <app-input
            type="text"
            prefixText="₹"
            formControlName="iqp_partly_pmnt_amnt"
            [readonly]="isFullPayment"
            placeholder="0.00"
            (inputKeydown)="onAmountKeyDown($event)">
          </app-input>
        </div>
      </div>

      <!-- Payment Method Dropdown -->
      <div class="payment-form__field">
        <app-select
          label="Payment Method"
          [required]="true"
          formControlName="iqp_payment_type"
          placeholder="Choose A Payment Channel"
          [options]="paymentMethodOptions"
          (selectionChange)="onPaymentMethodChange($event)">
        </app-select>
      </div>

      <!-- Reference ID -->
      <div class="payment-form__field">
        <app-input
          label="Reference ID / UTR"
          formControlName="iqp_payment_ref"
          placeholder="Enter Transaction Reference Number">
        </app-input>
      </div>

      <!-- Notes / Memo -->
      <div class="payment-form__field">
        <app-input
          label="Memo / Transaction Notes"
          [multiline]="true"
          [rows]="2"
          formControlName="notes"
          placeholder="Write Any Accounting Notes Or Description...">
        </app-input>
      </div>

      <!-- File Upload Zone -->
      <div class="payment-form__field">
        <app-label text="Proof of Payment / Screenshot" customClass="mb-2"></app-label>
        <div class="upload-zone" (click)="triggerFileInput(fileInput)" (dragover)="onDragOver($event)"
          (dragleave)="onDragLeave($event)" (drop)="onDrop($event)" [class.upload-zone--dragging]="isDragging">
          <input type="file" #fileInput (change)="onFileSelected($event)" style="display: none;">
          <div class="upload-zone__icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
              <polyline points="17 8 12 3 7 8"></polyline>
              <line x1="12" y1="3" x2="12" y2="15"></line>
            </svg>
          </div>
          <p class="upload-zone__title">Drag &amp; drop or <span>browse</span> to upload</p>
          <p class="upload-zone__hint">Supports PNG, JPG, PDF up to 4MB (Optional)</p>
        </div>

        <!-- Attachment List -->
        <div *ngIf="attachedFile" class="attachment-list">
          <div class="attachment-item">
            <div class="attachment-item__left">
              <div class="attachment-item__icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                  <polyline points="14 2 14 8 20 8"></polyline>
                  <line x1="16" y1="13" x2="8" y2="13"></line>
                  <line x1="16" y1="17" x2="8" y2="17"></line>
                </svg>
              </div>
              <div class="attachment-item__info">
                <p class="attachment-item__name">{{ attachedFile.name }}</p>
                <p class="attachment-item__size">{{ attachedFile.size }}</p>
              </div>
            </div>
            <div class="attachment-item__actions">
              <span class="attachment-item__badge" [class.attachment-item__badge--uploading]="isUploading"
                [class.attachment-item__badge--selected]="selectedFile && !isUploading">
                {{ isUploading ? 'Uploading...' : (selectedFile ? 'Attached' : 'Uploaded') }}
              </span>
              <button type="button" (click)="removeAttachment()" class="attachment-item__remove"
                aria-label="Remove attachment">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <polyline points="3 6 5 6 21 6"></polyline>
                  <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                  <line x1="10" y1="11" x2="10" y2="17"></line>
                  <line x1="14" y1="11" x2="14" y2="17"></line>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>

  <!-- Footer -->
  <div class="rp-drawer-footer">
    <app-button
      variant="outline"
      size="large"
      label="Cancel"
      [fullWidth]="true"
      class="flex-grow-1 flex-1"
      (btnClick)="onNoClick()">
    </app-button>

    <!-- Save Button (Add Mode) -->
    <app-button
      *ngIf="!editMode"
      variant="primary"
      size="large"
      label="Save"
      [loading]="isLoaderOn"
      [disabled]="paymentForm.invalid || checkIfAmountExceeds() || !invoiceNumber || isUploading"
      [fullWidth]="true"
      class="flex-grow-1 flex-1"
      (btnClick)="paymentFormSubmit()">
    </app-button>

    <!-- Edit Button (Edit Mode) -->
    <app-button
      *ngIf="editMode"
      variant="primary"
      size="large"
      label="Save Edits"
      [loading]="isLoaderOn"
      [disabled]="paymentForm.invalid || checkIfDueAmountExceeds() || isUploading"
      [fullWidth]="true"
      class="flex-grow-1 flex-1"
      (btnClick)="paymentFormEdit()">
    </app-button>
  </div>
</div>